import styled from "styled-components";

export const AudioButton = styled.span`
  color: ${props => props.theme.highlightColor};
  cursor: pointer;
`;


// WEBPACK FOOTER //
// ./src/components/QuizBox/AudioButton.tsx